import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * FAQAccordion — Bankrate/Investopedia-style FAQ block. Items expand on
 * click, all items closed by default. Designed to mirror the JSON-LD FAQ
 * schema we emit so what the reader sees is what Google's rich-results
 * crawler reads.
 */
export function FAQAccordion({ items }) {
  const [open, setOpen] = useState(null); // index of open item, or null
  if (!items?.length) return null;

  return (
    <section
      id="faq"
      className="not-prose mt-14 pt-12 border-t border-[#E5E7EB]"
      data-testid="blog-faq"
    >
      <div className="mb-7">
        <div className="uppercase-label">FAQ</div>
        <h2 className="font-display text-2xl sm:text-3xl text-[#0A2540] font-semibold tracking-tight mt-2 mb-0" id="faqs">
          Frequently asked questions
        </h2>
      </div>
      <ul className="divide-y divide-[#E5E7EB] border-y border-[#E5E7EB]">
        {items.map((it, i) => {
          const isOpen = open === i;
          return (
            <li key={i} data-testid={`faq-item-${i}`}>
              <button
                type="button"
                aria-expanded={isOpen}
                onClick={() => setOpen(isOpen ? null : i)}
                className="w-full flex items-start justify-between gap-5 text-left py-5 lg:py-6 group"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display text-[17px] lg:text-[18px] font-semibold text-[#0A2540] leading-snug group-hover:text-[#0066FF] transition-colors">
                  {it.q}
                </span>
                <ChevronDown
                  className={
                    "shrink-0 w-5 h-5 mt-0.5 text-[#6B7280] transition-transform duration-200 " +
                    (isOpen ? "rotate-180 text-[#0066FF]" : "")
                  }
                  aria-hidden="true"
                />
              </button>
              <div
                className={
                  "overflow-hidden transition-all duration-300 ease-out " +
                  (isOpen ? "max-h-[1200px] opacity-100 pb-6" : "max-h-0 opacity-0")
                }
              >
                <div
                  className="blog-prose text-[#374151] leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: it.a }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
